import { pickAFileSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    actions: [],
    rules: [],
    answers: [],
    autoFill: [],
    meta: [],
    details: [],
    questions: [],
    layout: [],
    serviceQuestions: [],
    serviceBrandQuestions: [],
    brandList: [],
    serviceList: [],
    selectedServiceList: [],
    selectedBrandList: []
}

export default function pickAFileSlice(state = initialState, action) {
    switch (action.type) {
        //setFileContents is used for refreshing the ctx screen data.
        case pickAFileSliceDispatch.setFileContents: {
            return {
                ...state,
                currentDataContents: action.payload
            }
        }
        case pickAFileSliceDispatch.setActions: {
            return {
                ...state,
                actions: action.payload
            }
        }
        case pickAFileSliceDispatch.setAssistanceFormId: {
            return {
                ...state,
                assistanceFormId: action.payload
            }
        }
        case pickAFileSliceDispatch.setBaseName: {
            return {
                ...state,
                baseName: action.payload
            }
        }
        case pickAFileSliceDispatch.setFileLength: {
            return {
                ...state,
                fileLength: action.payload
            }
        }
        case pickAFileSliceDispatch.setFormDescription: {
            return {
                ...state,
                formDescription: action.payload
            }
        }
        case pickAFileSliceDispatch.setFormName: {
            return {
                ...state,
                formName: action.payload
            }
        }
        case pickAFileSliceDispatch.setFormRuleSetId: {
            return {
                ...state,
                formRuleSetId: action.payload
            }
        }
        case pickAFileSliceDispatch.setInterfaceId: {
            return {
                ...state,
                interfaceId: action.payload
            }
        }
        case pickAFileSliceDispatch.setFileName: {
            return {
                ...state,
                fileName: action.payload
            }
        }
        case pickAFileSliceDispatch.setAddressStart: {
            return {
                ...state,
                addressStart: action.payload
            }
        }
        case pickAFileSliceDispatch.setAddressEnd: {
            return {
                ...state,
                addressEnd: action.payload
            }
        }
        case pickAFileSliceDispatch.setRules: {
            return {
                ...state,
                rules: action.payload
            }
        }
        case pickAFileSliceDispatch.setAnswers: {
            return {
                ...state,
                answers: action.payload
            }
        }
        case pickAFileSliceDispatch.setAutofill: {
            return {
                ...state,
                autoFill: action.payload
            }
        }
        case pickAFileSliceDispatch.setMeta: {
            return {
                ...state,
                meta: action.payload
            }
        }
        case pickAFileSliceDispatch.setDetails: {
            return {
                ...state,
                details: action.payload
            }
        }
        case pickAFileSliceDispatch.setQuestions: {
            return {
                ...state,
                questions: action.payload
            }
        }
        case pickAFileSliceDispatch.setLayout: {
            return {
                ...state,
                layout: action.payload
            }
        }
        case pickAFileSliceDispatch.setServiceQuestions: {
            return {
                ...state,
                serviceQuestions: action.payload
            }
        }
        case pickAFileSliceDispatch.setServiceBrandQuestions: {
            return {
                ...state,
                serviceBrandQuestions: action.payload
            }
        }
        case pickAFileSliceDispatch.setBrandList: {
            return {
                ...state,
                brandList: action.payload
            }
        }
        case pickAFileSliceDispatch.setSelectedBrandList: {
            return {
                ...state,
                selectedBrandList: action.payload
            }
        }
        case pickAFileSliceDispatch.setServiceList: {
            return {
                ...state,
                serviceList: action.payload
            }
        }
        case pickAFileSliceDispatch.setSelectedServiceList: {
            return {
                ...state,
                selectedServiceList: action.payload
            }
        }
        case pickAFileSliceDispatch.setFormContext: {
            return {
                ...state,
                formContext: action.payload
            }
        }
        case pickAFileSliceDispatch.setServiceDropDownList: {
            return {
                ...state,
                serviceDropDownList: action.payload
            }
        }
        case pickAFileSliceDispatch.setBrandDropDownList: {
            return {
                ...state,
                brandDropDownList: action.payload
            }
        }
        case pickAFileSliceDispatch.setHasMultipleServices: {
            return {
                ...state,
                hasMultipleServices: action.payload
            }
        }
        case pickAFileSliceDispatch.setHasMultipleBrands: {
            return {
                ...state,
                hasMultipleBrands: action.payload
            }
        }
        case pickAFileSliceDispatch.setBusinessRules: {
            return {
                ...state,
                businessRules: action.payload
            }
        }
        case pickAFileSliceDispatch.setFilePath: {
            return {
                ...state,
                filePath: action.payload
            }
        }
        default:
            return state
    }
}
